import {withFormsy} from 'formsy-react';
import React from 'react';
import PropTypes from 'prop-types'

class NumberInput extends React.Component {
    static propTypes = {
        precision: PropTypes.number,
    };

    static defaultProps = {
        precision: 0,
    };

    constructor(props) {
        super(props);

        this.state = {
            formId: this.getId(props)
        }
    }

    changeValue(event) {
        let inputValue = this.removeCommas(
            event.currentTarget.value
        );

        if (isNaN(inputValue)) {
            inputValue = '';
        }

        this.props.setValue(
            inputValue
        );
    }

    formatValue(value) {
        if (!value) {
            return;
        }

        let inputValue = this.removeCommas(value);
        if (isNaN(inputValue)) {
            return;
        }

        let rounded = TB.floor(inputValue, this.props.precision);
        if (isNaN(rounded)) {
            return;
        }

        return value;
    }

    addCommas(num) {
        if (!num) {
            return;
        }
        if (!TB.isString(num)) {
            num = num.toString();
        }
        let addDecimal = num.endsWith('.');

        let parsed = parseFloat(num).toLocaleString('en');
        if (addDecimal) {
            return parsed + '.';
        }

        return parsed;
    }

    removeCommas(num) {
        if (!TB.isString(num)) {
            num = num.toString();
        }

        num = num.replace(/[^\d.\,]/g, '');

        let addDecimal = num.endsWith('.');
        let parsed = parseFloat(num.replace(/\,/g, ''));
        if (addDecimal) {
            return parsed + '.';
        }

        return parsed;
    }


    getId(props) {
        let _a = props, id = _a.id, label = _a.label, name = _a.name;
        if (id !== '') {
            return id;
        }
        let inString = JSON.stringify(label), hash = 0;

        for (let i = 0; i < inString.length; i += 1) {
            hash = ((hash << 5) - hash + inString.charCodeAt(i)) & 0xffffffff;
        }
        return [
            'frc',
            name.split('[').join('_').replace(']', ''),
            hash,
        ].join('-');
    }

    render() {
        let props = this.props;
        const errorMessage = props.getErrorMessage();
        let className = props.showRequired() ? 'required ' : '';

        className += !props.isValid() && props.isFormSubmitted() ? 'text-danger' : '';
        let inputClassName = !props.isValid() && props.isFormSubmitted() ? 'is-invalid' : '';

        // getErrorMessage
        // getValue
        // hasValue
        // isFormDisabled
        // isValid
        // isPristine
        // isFormSubmitted
        // isRequired
        // isValidValue
        // resetValue
        // setValidations
        // setValue
        // showRequired
        // showError
        // label
        // type
        // addonBefore
        // required
        // maxLength
        // minLength

        return (
            <div className={"form-group " + className}>
                {props.label && (
                    <label className="col-form-label" data-required="true" htmlFor={this.state.formId}>
                        {props.label}
                        {props.required && <span className="required-symbol"> *</span>}
                    </label>
                )}

                <div className={"input-group " + (props.disabled && 'disabled')}>

                    {TB.isDefined(props.value) && (
                        <span className={"input-group-prepend " + (props.disabled && 'disabled')}>
                            <i className="fas fa-dollar-sign"/>
                         </span>
                    )}
                    <input
                        name={props.name}
                        min={props.minLength}
                        max={props.maxLength}
                        placeholder={props.placeholder}
                        className={"form-control " + inputClassName}
                        required={props.required}
                        disabled={props.disabled}
                        onChange={event => {
                            this.changeValue(event)
                        }}
                        onBlur={(e) => {
                            let formatted = this.formatValue(e.target.value);
                            if (!formatted) {
                                return;
                            }

                            this.props.setValue(
                                Number.parseFloat(formatted).toFixed(
                                    this.props.precision
                                )
                            );
                        }}
                        id={this.state.formId}
                        // type="number"
                        value={props.value || ''}
                    />
                </div>

                {errorMessage && (
                    <div className="invalid-feedback">
                        <div>{errorMessage}</div>
                    </div>
                )}
            </div>
        )
    }
}


export default withFormsy(NumberInput);
